import React from 'react';
import {connect} from 'react-redux'
// import {Api} from '../../libs/api'

// import {getCookie} from '../../libs/cookie'

import Login from '../layer/login'

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alertLogin: false
        }
    }

    // onEstimateTalkMove(opt) {

    //     if (this.props.userInfo === null) {
    //         this.onLogin()
    //         return false
    //     }

    //     let shopNO = this.props.miniShopInfo.shopNO
    //     let estimateItems = []
    //     let estimateChecked = this.props.estimateChecked

    //     for(let k in estimateChecked) {
    //         if (estimateChecked[k]) estimateItems.push(k+"|"+getCookie('cnt_'+k))
    //     }
    //     let params = {
    //         itemIds: estimateItems.join(','),
    //         user_idx: this.props.userInfo.user_idx,
    //         b_manager: shopNO
    //     }

    //     Api.addEstimate(params).then((rst)=>{
    //         if(rst.data.code === 200) {
    //             const idx_est = rst.data.result.idx_est
    //             window.open('//talk.pping.kr/ask/'+opt+'/'+idx_est)
    //         } else if (rst.data.code === 201) {
    //             window.location.href = 'https://sso.pping.kr';
    //         }
    //     })
    // }

    onLogin = () => {
        this.setState(state => ({
            alertLogin: !state.alertLogin
        }))
    }

    render() {
        if (this.props.selectCategory === null) return false
        return (
            <div className="cart-body_compare_other">
                {/* <ul>
                    <li>
                        <div>
                            <span>선택한 <em>견적의 호환성</em>이 궁금하다면</span>
                            <strong>PC견적 온라인</strong>
                            <button type="button" onClick={()=>this.onEstimateTalkMove('est5')}>상담하기</button>
                        </div>
                    </li>
                    <li>
                        <div>
                            <span>좀 더 <em>저렴한 구매</em>를 원하시면</span>
                            <strong>PC견적</strong>
                            <button type="button" onClick={()=>this.onEstimateTalkMove('est4')}>입찰하기</button>
                        </div>
                    </li>
                    <li>
                        <div>
                            <span>선택한 견적으로 <em>튜닝/오버클럭</em>을 원하시면</span>
                            <strong>튜닝/오버클럭</strong>
                            <a onClick={()=>this.onEstimateTalkMove('est3')}>상담ㆍ구매하기</a>
                        </div>
                    </li>
                </ul> */}
                {this.state.alertLogin && <Login onLogin={this.onLogin} />}
            </div>
        )
    }
}

let stateData = (state) => {
    return {
        selectCategory:state.initial.selectCategory,
        estimateChecked:state.estimateAdd.estimateChecked,
        miniShopInfo: state.initial.minishopInfo,
        userInfo:state.user.userInfo,
    };
};

export default connect(stateData)(Footer);
// export default Default;



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/footer.js